import { Loader2 } from 'lucide-react';

/**
 * Suspense fallback for every lazy-loaded route (router.tsx). Deliberately
 * plain and shell-agnostic -- it renders inside whichever layout's Outlet
 * is loading (marketing, admin, driver, supervisor), so it can't assume
 * any one shell's chrome or background is already on screen.
 */
export function PageLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <Loader2 size={28} className="animate-spin text-charcoal/40" />
    </div>
  );
}
